import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, Router } from '@angular/router';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { FooterComponent } from '../../shared/components/footer/footer.component';
import { CartDrawerComponent } from '../../shared/components/cart-drawer/cart-drawer.component';
import { ScrollToTopComponent } from '../../shared/components/scroll-to-top/scroll-to-top.component';
import { AnalyticsConsentComponent } from '../../shared/components/analytics-consent/analytics-consent.component';

@Component({
  selector: 'app-public-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    CartDrawerComponent,
    ScrollToTopComponent,
    AnalyticsConsentComponent,
  ],
  template: `
    <app-header></app-header>
    <main class="global-main" [class.navbar-padding]="!isHome()">
      <router-outlet></router-outlet>
    </main>
    <app-footer></app-footer>
    <app-analytics-consent></app-analytics-consent>
    <app-cart-drawer></app-cart-drawer>
    <app-scroll-to-top [theme]="getScrollTheme()"></app-scroll-to-top>
  `,
  styles: [
    `
      .global-main {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
      }
    `,
  ],
})
export class PublicLayoutComponent {
  private router = inject(Router);

  isHome() {
    const url = this.router.url.split('?')[0];
    return url === '/' || url === '' || url === '/home';
  }

  getScrollTheme(): 'glass' | 'minimal' {
    const url = this.router.url.split('?')[0];
    const glassRoutes = ['/yachts', '/merchandise', '/boat-detail', '/merchandise-detail'];
    return glassRoutes.some((route) => url.startsWith(route)) ? 'glass' : 'minimal';
  }
}
